import React from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";

const customStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "white",
    borderColor: "#d1d5db", 
    fontSize: "0.875rem",
    minHeight: "2.5rem",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#9ca3af",
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "#f3f4f6" : "white",
    color: "#111827",
    padding: "0.5rem 1rem",
    fontSize: "0.875rem",
  }),
};

const SelectDropdown = ({
  options = [],
  useServer = false,
  loadOptions, 
  onChange,
  isMulti = false,
  isClearable = true,
  placeholder = "Select...",
}) => {
  const SelectComponent = useServer ? AsyncSelect : Select;

  const filterOptions = (inputValue) => {
    return options.filter((opt) =>
      opt.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const promiseOptions = (inputValue) =>
    useServer
      ? loadOptions(inputValue)
      : new Promise((resolve) => {
          resolve(filterOptions(inputValue));
        });

  return (
    <SelectComponent
      styles={customStyles}
      isMulti={isMulti}
      isClearable={isClearable}
      placeholder={placeholder}
      loadOptions={promiseOptions}
      options={!useServer ? options : undefined}
      onChange={onChange}
      closeMenuOnSelect={!isMulti}

      className="text-sm"
    />
  );
};

export default SelectDropdown;
